module.exports = __webpack_public_path__ + "media/assets/images/blog/contact_flow_example-89e468d44dcd620f8a5b7903f5bc7d16.png";